// import React, { useEffect, useState } from 'react';
// import Http from "../../Http";
// import { AdBanner_API } from "../../Helper";

// const AdBanner = () => {
//   const [banners, setBanners] = useState([]);

//   useEffect(() => {
//     const fetchBanners = async () => {
//       try {
//         const data = await Http.get(AdBanner_API); // ✅ Already the raw data
//         console.log("Raw API response:", data);

//         const bannerList = data?.banners || [];
//         setBanners(Array.isArray(bannerList) ? bannerList : []);
//       } catch (error) {
//         console.error("Error fetching banners:", error);
//         setBanners([]);
//       }
//     };

//     fetchBanners();
//   }, []);

//   // ✅ Get current page from the last segment of path
//   const pathSegments = window.location.pathname.split("/");
//   const currentPage = pathSegments[pathSegments.length - 1];
//   console.log("Current Page:", currentPage);

//   const filteredBanners = banners
//     .filter(b => b.page_url === currentPage)
//     .sort((a, b) => Number(a.display_order) - Number(b.display_order));

//   console.log("Banner page_urls:", banners.map(b => b.page_url));

//   return (
//     <div className="">
//       {filteredBanners.length > 0 ? (
//         filteredBanners.map((banner) => (
//           <a
//             key={banner.id}
//             href={banner.img_redirect_link}
//             target="_blank"
//             rel="noopener noreferrer"
//             className=""
//           >
//             <img
//               src={banner.image}
//               alt={banner.img_title}
//               className=""
//             />
//             <div className="p-4">
//               <h3 className="text-lg font-bold mb-1">{banner.img_title}</h3>
//               <p className="text-sm text-gray-600">{banner.img_desc}</p>
//             </div>
//           </a>
//         ))
//       ) : (
//         <div className="text-center text-gray-500 w-full col-span-full">
//           No ads available for this page.
//         </div>
//       )}
//     </div>
//   );
// };

// export default AdBanner;
import React, { useEffect, useState } from 'react';
import Http from "../../Http";
import { AdBanner_API } from "../../Helper";

const AdBanner = ({ displayOrder }) => {
  const [banners, setBanners] = useState([]);

  useEffect(() => {
    const fetchBanners = async () => {
      try {
        const data = await Http.get(AdBanner_API);
        const bannerList = data?.banners || [];
        setBanners(Array.isArray(bannerList) ? bannerList : []);
      } catch (error) {
        console.error("Error fetching banners:", error);
        setBanners([]);
      }
    };

    fetchBanners();
  }, []);

  // Get the current page path segment
  const pathSegments = window.location.pathname.split("/");
  const currentPage = pathSegments[pathSegments.length - 1] || "home";


  // Filter by current page and specific displayOrder
  const filteredBanners = banners
    .filter(b => b.page_url === currentPage && String(b.display_order) === String(displayOrder));


  return (
    <div>
      {filteredBanners.length > 0 &&
        filteredBanners.map((banner) => (
          <a
            key={banner.id}
            href={banner.img_redirect_link}
            target="_blank"
            rel="noopener noreferrer"
          >
            <img
              src={banner.image}
              alt={banner.img_title}
              className="w-full h-auto object-contain rounded-lg shadow-md transition duration-300 "
            />
            {/* {(banner.img_title || banner.img_desc) && (
              <div className="p-2">
                {banner.img_title && (
                  <h3 className="text-base font-bold mb-1">{banner.img_title}</h3>
                )}
                {banner.img_desc && (
                  <p className="text-sm text-gray-600">{banner.img_desc}</p>
                )}
              </div>
            )} */}
          </a>
      //   ))
      // ) : (
      //   <div className="text-center text-gray-500 w-full">
      //     No ads available for this section.
      //   </div>
      ))}
    </div>
  );
};

export default AdBanner;
